import { ILoaderActionTypes } from "action/interfaces/loader.interface";

const loaderReducer = (state = { isLoading: false }, action: ILoaderActionTypes) => {
  switch (action.type) {
  case "SHOW_LOADER":
    return { isLoading: true };

  case "HIDE_LOADER":
    return { isLoading: false };

  default:
    return state;
  }
};

export default loaderReducer;
